import { ClientWebPage } from '@common/model/meta/clientWebPage';
import { useClientWebRouteProps } from '@cp/entities/clientWebRoutes';
import { getIsSubcatalog } from '../lib';

export const useIsSubcatalog = () => {
  const pageProps = useClientWebRouteProps<ClientWebPage.Catalog>();

  return getIsSubcatalog(pageProps);
};
